import axios from "axios";
import { toast } from "react-toastify";
import { webPath } from "../config.json";

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    //toast.error("An unexpected error occurrred.");
  } else if (error.response.status === 401) {
    window.location = webPath + "/login";
  } else {
    //toast.error(error.response.statusText);
  }

  return Promise.reject(error);
});

function setToken(token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

function setLanguage(languageId) {
  axios.defaults.headers.common["languageId"] = languageId;
}

var languageId = localStorage.getItem("CokeAdminLanguageId");

if (languageId != null) {
  axios.defaults.headers.common["languageId"] = languageId;
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setToken,
  setLanguage,
};
